var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.holidays.data.length)?_c('div',[_c('div',{staticClass:"d-flex"},[_c('v-pagination',{attrs:{"length":_vm.holidays.last_page},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1),_vm._v(" "),_c('holiday-table',{attrs:{"holidays":_vm.holidays.data}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }